<div [ngClass]="[(color ? color : ''), (border ? 'border': '')]"  class="app-button" (click)="cta.emit($event)">
  <fa-icon *ngIf="preButton" [icon]="preButton" class="preButton" ></fa-icon>
  <span *ngIf="isLink && !centerButton" [class.submit-button-small]="isSmall == true" [class.submit-button-large]="isSmall == false"
   class="btn-solid-lg page-scroll" style="pointer-events: none;" >{{ title }}</span>
   <fa-icon *ngIf="centerButton" [icon]="centerButton" class="centerButton" ></fa-icon>
   <fa-icon *ngIf="nextButton" [icon]="nextButton" class="nextButton" ></fa-icon>
</div>
